module.exports = __webpack_public_path__ + "8d47efa598132b2fc8371498f01e9dad.png";